/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Address from './Address/index'
import BackAction from './BackAction/index'
import Details from './Details/index'
import Email from './Email/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import Phone from './Phone/index'
import React from 'react'
import Relationship from './Relationship/index'
import SaveAction from './SaveAction/index'
import Title from './Title/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/NewPhone/Content/NewRelation/Add/Content"
  
}) {
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 maxHeight="98%"
 overflowY="scroll"
 height="auto"
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Title
  viewPath={`${viewPath}/Title`}
/>
</div>
<Relationship
  viewPath={`${viewPath}/Relationship`}
/>
<Details
  viewPath={`${viewPath}/Details`}
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--blc-1-Z1Yf8zk': dtColorsNeutral400,'--pl-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mb-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<Address
  viewPath={`${viewPath}/Address`}
/>
</div>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 style={{'--blc-1-Z1Yf8zk': dtColorsNeutral400,'--pl-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mb-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<Phone
  viewPath={`${viewPath}/Phone`}
/>
</div>
</div>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<div
  data-testid="Content.Vertical:3"
  data-view-path={viewPath}
 style={{'--blc-1-Z1Yf8zk': dtColorsNeutral400,'--pl-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mb-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical2}`}
>
<Email
  viewPath={`${viewPath}/Email`}
/>
</div>
</div>
<div
  data-testid="Content.Horizontal:3"
  data-view-path={viewPath}
 style={{'--mt-5-Z1Yf8zk': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Horizontal3}`}
>
<BackAction
  viewPath={`${viewPath}/BackAction`}
/>
<SaveAction
  viewPath={`${viewPath}/SaveAction`}
/>
</div>
</div>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}